import { resolveStoreRelationAssignmentStatus } from './storeRelationAssignmentUtils'

import {
  STORE_RELATION_DEFAULT_STATUS,
  STORE_RELATION_STATUS_VALUES
} from '../constants/storeConstants'

export const normalizeStoreRelationStatus = (status) => {
  return STORE_RELATION_STATUS_VALUES.includes(status) ? status : STORE_RELATION_DEFAULT_STATUS
}

export const hasStoreRelationPrincipalConflict = (storeRelation) => {
  return (
    storeRelation?.flow?.mode === 'conflict' ||
    storeRelation?.flow?.action === 'resolve_principal_conflict'
  )
}

export const hasStoreRelationAssignedPrincipal = (storeRelation) => {
  return Boolean(storeRelation?.client_principal?.salesman)
}

export const hasStoreRelationPendingPrincipalAssignment = (storeRelation) => {
  if (hasStoreRelationPrincipalConflict(storeRelation)) return false
  if (storeRelation?.flow?.action === 'create_new_relation') return true

  return !hasStoreRelationAssignedPrincipal(storeRelation)
}

export const canStoreRelationAssignPrincipal = (storeRelation) => {
  if (!hasStoreRelationPendingPrincipalAssignment(storeRelation)) return false

  return Boolean(
    storeRelation?.flow?.action === 'create_new_relation' ||
      storeRelation?.client_configuration?.id ||
      storeRelation?.client_configuration?.store_reference
  )
}

export const isStoreRelationClientInactive = (storeRelation) => {
  return storeRelation?.client?.active === false
}

export const resolveStoreRelationSecondaryStatus = (relation) => {
  const statusSummary = resolveStoreRelationAssignmentStatus(relation)

  if (statusSummary.hasAnyError) return 'error'
  if (statusSummary.hasAnySuspended) return 'suspended'

  return normalizeStoreRelationStatus(relation?.status)
}

export const resolveStoreRelationOverallStatus = (storeRelation) => {
  const principalStatus = storeRelation?.client_principal?.status
  const secondaryStatusSummary = resolveStoreRelationAssignmentStatus(storeRelation?.client_brands || [])

  if (hasStoreRelationPrincipalConflict(storeRelation)) return 'error'
  if (principalStatus === 'error') return 'error'
  if (principalStatus === 'suspended') return 'suspended'
  if (secondaryStatusSummary.hasAnyError) return 'error'
  if (secondaryStatusSummary.hasAnySuspended) return 'suspended'
  return STORE_RELATION_DEFAULT_STATUS
}
